function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#4A4757",
  d: "M14.706 1v2.178h-2.229v2.215H6.61L18 24.996 29.392 5.393h-8.09V3.215h2.21V1H32.2C33.746 1 35 2.246 35 3.782c0 .489-.13.968-.375 1.391l-14.2 24.435a2.81 2.81 0 0 1-4.85 0L1.375 5.173a2.772 2.772 0 0 1 1.026-3.8A2.814 2.814 0 0 1 3.8 1h10.905z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00BBE6",
  d: "M18.004 16.229a1.56 1.56 0 0 1 1.566 1.555c0 .422-.168.804-.442 1.084v.033h-.033c-.282.272-.667.44-1.09.44a1.56 1.56 0 0 1-1.567-1.557 1.56 1.56 0 0 1 1.566-1.555z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C263BF",
  d: "M19.128 7.626v2.196h-2.211V7.626z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF8BA2",
  d: "M16.917 5.429v2.197h-2.211V5.429z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4A4757",
  fillOpacity: 0.2,
  d: "M23.512 1v2.215h-2.211V1zm-8.806 2.178v2.215h-2.233V3.178z"
}));

var SvgLogoVermeColor = function SvgLogoVermeColor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoVermeColor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo_verme_color.66c95870.svg";
export { ForwardRef as ReactComponent };